import React from 'react';
import { FiEdit } from 'react-icons/fi';
import { DATE_FORMAT } from '../../../../../constants/service/common/utilConstants';
import { REMOTE_REFERRAL_IMAGE_EDIT_URL_PATH } from '../../../../../constants/service/common/urlConstants';
import {
  REMOTE_REFERRAL_IMAGE_EXPOSE_LOCATION_TYPE_TEXT,
  REMOTE_REFERRAL_LINK_TYPE_TEXT,
  REMOTE_IMAGE_ACTIVE_STATUS_TYPE_TEXT,
} from '../../../../../constants/service/app/remoteImageConstants';
import { reDirectPage, setDash, setDetailPageUrl } from '../../../../../lib/common';
import { setDateFormat } from '../../../../../lib/moment';

/**
 *  원격 이미지 리스트 컬림
 */
export const columns = () => {
  return [
    {
      title: '수정',
      dataIndex: 'edit',
      render: (value, record) => (
        <FiEdit
          onClick={() =>
            reDirectPage({
              path: setDetailPageUrl(REMOTE_REFERRAL_IMAGE_EDIT_URL_PATH, record.id),
            })
          }
        />
      ),
    },
    {
      title: '레퍼럴 ID',
      dataIndex: 'id',
    },
    {
      title: '노출위치 타입',
      dataIndex: 'type',
      render: (value) => REMOTE_REFERRAL_IMAGE_EXPOSE_LOCATION_TYPE_TEXT[value],
    },
    {
      title: '링크 타입',
      dataIndex: 'linkType',
      render: (value) => setDash(REMOTE_REFERRAL_LINK_TYPE_TEXT[value]),
    },
    {
      title: '생성일',
      dataIndex: 'createDate',
      render: (value) => setDateFormat(value, DATE_FORMAT.FULL_DASH_FORMAT),
    },
    {
      title: '메모',
      dataIndex: 'memo',
      render: (value) => setDash(value),
    },
    {
      title: '활성상태',
      dataIndex: 'status',
      render: (value) => setDash(REMOTE_IMAGE_ACTIVE_STATUS_TYPE_TEXT[value]),
    },
  ];
};
